import React from 'react';
import {
    GetStageSheet_getStageSheet_propDetails as ProppantDetailsType,
    GetStageSheet_getStageSheet_details as StageSheetType,
} from '../../../../types/schemaTypes';
import './StageSheet.scss';
import {NumericFormat as NumberFormat} from 'react-number-format';

export interface PrintStageSheetProps {
    jobName: string;
    wellheadStages: string;
    proppantDetails: ProppantDetailsType[] | undefined;
    stageSheets: StageSheetType[] | undefined;
    innerRef?: React.RefObject<HTMLDivElement | null>;
}

export class StageSheetPrintForkliftLayout extends React.Component<PrintStageSheetProps> {
    public render() {
        const { jobName, wellheadStages, proppantDetails, stageSheets, innerRef } = this.props;

        return (
            <div className="StageSheet-Grid-Container-To-Print-Forklift" ref={innerRef}>
                <div className="StageSheet-Header-To-Print-Forklift">
                    {jobName} - {wellheadStages}
                </div>

                <div className="StageSheet-Grid-Container-To-Print">
                    <table className="StageSheet-Grid-To-Print">
                        <thead>
                            <tr>
                                <th>Proppant</th>
                                <th>Total Weight Needed</th>
                                <th>Sand Pumped</th>
                                <th>Cumulative Box Weight</th>
                            </tr>
                        </thead>

                        <tbody className="StageSheet-Row-To-Print">
                            {proppantDetails &&
                                proppantDetails.map((proppantDetail, index) => (
                                    <tr
                                        key={index}
                                        style={{ backgroundColor: `${index % 2 === 0 ? '#f2f2f2' : '#fff'}` }}
                                    >
                                        <td>{proppantDetail.proppantName}</td>
                                        <td
                                            className={
                                                proppantDetail.totalWeightNeeded && proppantDetail.totalWeightNeeded < 0
                                                    ? 'Td-Red-Background'
                                                    : ''
                                            }
                                        >
                                            <NumberFormat
                                                value={proppantDetail.totalWeightNeeded || 0}
                                                displayType={'text'}
                                                thousandSeparator={true}
                                            />
                                        </td>
                                        <td>
                                            <NumberFormat
                                                value={proppantDetail.sandPumped || 0}
                                                displayType={'text'}
                                                thousandSeparator={true}
                                            />
                                        </td>
                                        <td>
                                            <NumberFormat
                                                value={proppantDetail.totalBoxWeight || 0}
                                                displayType={'text'}
                                                thousandSeparator={true}
                                            />
                                        </td>
                                    </tr>
                                ))}
                        </tbody>
                    </table>
                </div>

                <div className="StageSheet-Grid-Container-To-Print">
                    <table className="StageSheet-Grid-To-Print">
                        <thead>
                            <tr>
                                <th>Station #</th>
                                <th>Box</th>
                                <th>Weight</th>
                                <th>Accumulated Weight</th>
                                <th>Type</th>
                                <th>Pad Location</th>
                                <th>Wt. Remaining</th>
                                <th>OOS</th>
                            </tr>
                        </thead>

                        <tbody className="StageSheet-Row-To-Print">
                            {stageSheets &&
                                stageSheets.map((stageSheet, index) => (
                                    <tr
                                        key={index}
                                        style={{ backgroundColor: `${index % 2 === 0 ? '#f2f2f2' : '#fff'}` }}
                                    >
                                        <td>{stageSheet.station === '0' ? '' : stageSheet.station}</td>
                                        <td>
                                            <div className="StageSheet-GreenDot-Container">
                                                {stageSheet.boxDesc}
                                                {stageSheet.isPartial === 'Yes' && (
                                                    <div className="StageSheet-GreenDot" />
                                                )}
                                            </div>
                                        </td>
                                        <td>
                                            <NumberFormat
                                                value={stageSheet.boxWeight || 0}
                                                displayType={'text'}
                                                thousandSeparator={true}
                                            />
                                        </td>
                                        <td>
                                            <NumberFormat
                                                value={stageSheet.accumulatedWeight || 0}
                                                displayType={'text'}
                                                thousandSeparator={true}
                                            />
                                        </td>
                                        <td>{stageSheet.proppant}</td>
                                        <td>{stageSheet.location}</td>
                                        <td>
                                            <NumberFormat
                                                value={stageSheet.boxWeightRemaining || 0}
                                                displayType={'text'}
                                                thousandSeparator={true}
                                            />
                                        </td>
                                        <td>{stageSheet.isOOS ? 'Yes' : 'No'}</td>
                                    </tr>
                                ))}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}
